class ExtendSectionS1LP1 extends ExtendSectionBase {
  constructor() {
    super();
  }

  init() {
    this._listenSectionLoad();
    const _safeInit = (fn) => {
      try {
        return fn();
      } catch (e) {
        console.warn(`[ExtendSectionS1V3] ${fn.name} 初始化失败:`, e);
        return null;
      }
    };
    _safeInit(() => this.carryParams());
    _safeInit(() => this.initHero());
    _safeInit(() => this.initWorkflow());
    _safeInit(() => this.initCreators());
    _safeInit(() => this.initRecordingModes());
    _safeInit(() => this.initPurchase());
    // 滚动驱动
    this._scrollEffects = [_safeInit(() => this.initHeader())].filter(Boolean);
    if (!!this._scrollEffects) {
      this._scrollEffects.forEach((fn) => fn());
    }
  }

  onScroll() {
    if (!!this._scrollEffects) {
      this._scrollEffects.forEach((fn) => fn());
    }
  }

  carryParams() {
    var currentParams = new URLSearchParams(window.location.search);
    var productLinks = document.querySelectorAll("a[data-carry-url-params]");

    for (var i = 0; i < productLinks.length; i++) {
      var link = productLinks[i];

      if (link.hasAttribute("data-carry-url-params-bound")) {
        continue;
      }

      var lpVersion = link.getAttribute("data-lp-version");
      var productUrl;

      try {
        productUrl = new URL(link.href, window.location.href);
      } catch (error) {
        continue;
      }

      if (
        productUrl.origin !== window.location.origin ||
        productUrl.pathname.indexOf("/products/") !== 0
      ) {
        continue;
      }

      currentParams.forEach(function (value, key) {
        if (key === "lp_version" || !productUrl.searchParams.has(key)) {
          productUrl.searchParams.set(key, value);
        }
      });

      if (lpVersion) {
        productUrl.searchParams.set("lp_version", lpVersion);
      }

      link.href = productUrl.pathname + productUrl.search + productUrl.hash;
      link.setAttribute("data-carry-url-params-bound", "true");
    }
  }

  initHeader() {
    const headerEl = this._q(".extend-s1lp1-header");
    if (!headerEl) return;
    const rail = this._q(".es1lp1h__progress-rail span", headerEl);
    return () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      rail.style.width = (max ? (scrollTop / max) * 100 : 0) + "%";
      headerEl.classList.toggle("is-sticky", scrollTop > 46);
    };
  }

  initHero() {
    const heroEl = this._q(".extend-s1lp1-hero");
    if (!heroEl) return;
    const _initSpecs = () => {
      const specs = this._qa("[name='spec']", heroEl);
      const specCards = this._qa("[name='spec-card']", heroEl);
      if (!specs.length) return;
      const specsModal = this._q("[name='specs-modal']", heroEl);
      specs.forEach((specEl, index) => {
        specEl.addEventListener("click", () => {
          specsModal.classList.add("open");
          specCards.forEach((el, elIndex) => {
            el.classList.remove("active");
          });
          specCards[index].classList.add("active");
        });
      });
    };
    const _initHeroTabs = () => {
      const tabs = this._qa("[name='media-tab']", heroEl);
      const mediaCards = this._qa("[name='media-card']", heroEl);
      const creatorVideosModal = this._q(
        "[name='creator-videos-modal']",
        heroEl
      );
      const creatorVideoCards = this._qa("[name='creator-video-card']", heroEl);
      if (!tabs.length) return;
      tabs[0].classList.add("active");
      mediaCards[0].classList.add("active");
      tabs.forEach((tabEl, index) => {
        tabEl.addEventListener("click", () => {
          if (tabEl.classList.contains("active")) return;
          tabs.forEach((el, elIndex) => {
            el.classList.remove("active");
            mediaCards[elIndex].classList.remove("active");
          });
          tabEl.classList.add("active");
          mediaCards[index].classList.add("active");
        });
      });
      mediaCards.forEach((cardEl, index) => {
        const btn = this._q("[name='media-full-btn']", cardEl);
        if (!btn) return;
        btn.addEventListener("click", () => {
          creatorVideoCards.forEach((el) => {
            el.classList.remove("active");
          });
          creatorVideosModal.classList.add("open");
          creatorVideoCards[index].classList.add("active");
          const videoMedia = this._q("video-media", creatorVideoCards[index]);
          if (!!videoMedia) {
            videoMedia.play();
          }
        });
      });
    };
    const _initProductCards = () => {
      const dots = this._qa("[name='product-dot']", heroEl);
      const cards = this._qa("[name='product-card']", heroEl);
      if (!dots.length) return;
      dots[0].classList.add("active");
      cards[0].classList.add("active");
      dots.forEach((dotEl, index) => {
        dotEl.addEventListener("click", () => {
          if (dotEl.classList.contains("active")) return;
          dots.forEach((el, elIndex) => {
            el.classList.remove("active");
            cards[elIndex].classList.remove("active");
          });
          dotEl.classList.add("active");
          cards[index].classList.add("active");
        });
      });
    };
    const _initProductStage = () => {
      const parallax = this._q("[data-parallax]", heroEl);
      if (matchMedia("(pointer:fine)").matches) {
        parallax.addEventListener("pointermove", (e) => {
          const r = parallax.getBoundingClientRect(),
            x = (e.clientX - r.left) / r.width - 0.5,
            y = (e.clientY - r.top) / r.height - 0.5;
          this._q(".es1lp1h__product-stage", parallax).style.transform =
            `rotateY(${x * 6 - 3}deg) rotateX(${y * -4}deg)`;
        });
        parallax.addEventListener(
          "pointerleave",
          () =>
            (this._q(".es1lp1h__product-stage", parallax).style.transform =
              "rotateY(-3deg)")
        );
      }
    };
    const _initHeroModals = () => {
      const modals = this._qa(".es1lp1h__modal", heroEl);
      if (!modals.length) return;
      modals.forEach((modalEl, index) => {
        const modalName = modalEl.getAttribute("name");
        const closeBtn = this._q(".es1lp1h__modal-close", modalEl);
        modalEl.addEventListener("click", (event) => {
          if (event.target !== event.currentTarget) return;
          modalEl.classList.remove("open");
        });
        closeBtn.addEventListener("click", () => {
          modalEl.classList.remove("open");
          if (modalName == "creator-videos-modal") {
            let videoMedia = this._q("video-media[playing]", modalEl);
            if (!!videoMedia) {
              videoMedia.pause();
            }
          }
        });
      });
    };
    _initSpecs();
    _initHeroTabs();
    _initProductCards();
    _initProductStage();
    _initHeroModals();
  }

  initWorkflow() {
    const workflowEl = this._q(".extend-s1lp1-workflow");
    if (!workflowEl) return;
    const _initSelector = () => {
      const options = this._qa("[name='option']", workflowEl);
      const stages = this._qa("[name='stage']", workflowEl);
      if (!options.length) return;
      options.forEach((optionEl, index) => {
        optionEl.addEventListener("click", () => {
          options.forEach((el, elIndex) => {
            el.classList.remove("active");
            stages[elIndex].classList.remove("active");
          });
          optionEl.classList.add("active");
          stages[index].classList.add("active");
          // const videoMedia = this._q("video-media", stages[index]);
          // if (!!videoMedia) {
          //   videoMedia.play();
          // }
        });
      });
    };
    _initSelector();
  }

  initCreators() {
    const creatorsEl = this._q(".extend-s1lp1-creators");
    if (!creatorsEl) return;
    const players = this._qa("[name='player']", creatorsEl);
    const infos = this._qa("[name='info']", creatorsEl);
    const tabs = this._qa(".es1lp1c__creator-tab", creatorsEl);
    const _initTabs = () => {
      tabs.forEach((tabEl, index) => {
        tabEl.addEventListener("click", () => {
          _toggleItem(index);
          // const videoMedia = this._q("video-media", players[index]);
          // if (!!videoMedia) {
          //   videoMedia.play();
          // }
        });
      });
    };
    const _initPlayers = () => {
      const creatorVideosModal = this._q(
        "[name='creator-videos-modal']",
        creatorsEl
      );
      const creatorVideoCards = this._qa(
        "[name='creator-video-card']",
        creatorsEl
      );
      players.forEach((playerEl, index) => {
        const btnEl = this._q(".es1lp1c__player-play-sound", playerEl);
        btnEl.addEventListener("click", () => {
          creatorVideoCards.forEach((el) => {
            el.classList.remove("active");
          });
          creatorVideosModal.classList.add("open");
          creatorVideoCards[index].classList.add("active");
          const videoMedia = this._q("video-media", creatorVideoCards[index]);
          if (!!videoMedia) {
            videoMedia.play();
          }
        });
      });
    };
    const _toggleItem = (index) => {
      tabs.forEach((el, elIndex) => {
        el.classList.remove("active");
        players[elIndex].classList.remove("active");
        infos[elIndex].classList.remove("active");
      });
      players[index].classList.add("active");
      infos[index].classList.add("active");
      tabs[index].classList.add("active");
    };
    const _initCreatorsModals = () => {
      const modals = this._qa(".es1lp1c__modal", creatorsEl);
      if (!modals.length) return;
      modals.forEach((modalEl, index) => {
        const modalName = modalEl.getAttribute("name");
        const closeBtn = this._q(".es1lp1c__modal-close", modalEl);
        modalEl.addEventListener("click", (event) => {
          if (event.target !== event.currentTarget) return;
          modalEl.classList.remove("open");
        });
        closeBtn.addEventListener("click", () => {
          modalEl.classList.remove("open");
          if (modalName == "creator-videos-modal") {
            let videoMedia = this._q("video-media[playing]", modalEl);
            if (!!videoMedia) {
              videoMedia.pause();
            }
          }
        });
      });
    };
    _initTabs();
    _initPlayers();
    _initCreatorsModals();
  }

  initRecordingModes() {
    const recordingModesEl = this._q(".extend-s1lp1-recording-modes");
    if (!recordingModesEl) return;
    const _initRouteWorkspaces = () => {
      const modeTabs = this._qa("[name='mode-tab']", recordingModesEl);
      const routeWorkspaces = this._qa(
        ".es1lp1rm__route-workspace",
        recordingModesEl
      );
      modeTabs.forEach((modeTabEl, modeTabIndex) => {
        const pillars = this._qa(
          ".es1lp1rm__pillar",
          routeWorkspaces[modeTabIndex]
        );
        pillars.forEach((p) =>
          p.addEventListener("click", () => {
            pillars.forEach((x) => x.classList.toggle("active", x === p));
          })
        );
        modeTabEl.addEventListener("click", () => {
          modeTabs.forEach((el, index) => {
            el.classList.remove("active");
            routeWorkspaces[index].classList.remove("active");
          });
          modeTabEl.classList.add("active");
          routeWorkspaces[modeTabIndex].classList.add("active");
        });
      });
    };
    const _initDAWChips = () => {
      const dawEl = this._q(
        ".es1lp1rm__route-workspace--daw",
        recordingModesEl
      );
      if (!dawEl) return;
      const chips = this._qa("[data-name='chip']", dawEl);
      const notes = this._qa("[data-name='note']", dawEl);
      chips.forEach((chipEl, chipIndex) => {
        chipEl.addEventListener("click", () => {
          chips.forEach((el, index) => {
            el.classList.remove("active");
            notes[index].classList.remove("active");
          });
          chipEl.classList.add("active");
          notes[chipIndex].classList.add("active");
        });
      });
    };
    const _initAppViewTabs = () => {
      const hisongEl = this._q(
        ".es1lp1rm__route-workspace--hisong",
        recordingModesEl
      );
      if (!hisongEl) return;
      const tabs = this._qa("[data-name='app-view-tab']", hisongEl);
      const shots = this._qa("[data-name='app-shot']", hisongEl);
      const modes = this._qa("[data-name='app-console-mode']", hisongEl);
      tabs.forEach((tabEl, tabIndex) => {
        tabEl.addEventListener("click", () => {
          tabs.forEach((el, index) => {
            el.classList.remove("active");
            shots[index].classList.remove("active");
            modes[index].classList.remove("active");
          });
          tabEl.classList.add("active");
          shots[tabIndex].classList.add("active");
          modes[tabIndex].classList.add("active");
        });
      });
    };
    const _initHisongPanel = () => {
      this._qa("[data-profile]", recordingModesEl).forEach((btn) =>
        btn.addEventListener("click", () => {
          this._qa("[data-profile]", recordingModesEl).forEach((b) =>
            b.classList.toggle("active", b === btn)
          );
        })
      );
      // this._qa("[data-record-action]", recordingModesEl).forEach((btn) =>
      //   btn.addEventListener("click", () => {
      //     const action = btn.dataset.recordAction;
      //     if (action === "pause")
      //       btn.textContent = btn.textContent.includes("Pause")
      //         ? "▶ Resume"
      //         : "Ⅱ Pause";
      //   })
      // );
      const toneLabels = {
        "-3": "75% Dark",
        "-2": "50% Dark",
        "-1": "25% Dark",
        0: "Natural",
        1: "+25% Bright",
        2: "+50% Bright",
        3: "+75% Bright",
      };
      const toneRange = this._q("#toneRange", recordingModesEl);
      if (toneRange) {
        toneRange.addEventListener(
          "input",
          (e) =>
            (this._q("#toneValue", recordingModesEl).textContent =
              toneLabels[e.target.value])
        );
      }
      const reverb = this._q("#reverbRange", recordingModesEl);
      if (reverb) {
        reverb.addEventListener(
          "input",
          (e) =>
            (this._q("#reverbValue", recordingModesEl).textContent =
              e.target.value)
        );
      }
      const compressor = this._q("#compressorToggle", recordingModesEl);
      if (compressor) {
        compressor.addEventListener("click", () => {
          compressor.classList.toggle("on");
          track("app_control_interaction", {
            control: "compressor",
            value: compressor.classList.contains("on"),
          });
        });
      }
      this._qa("[data-compressor]", recordingModesEl).forEach((btn) =>
        btn.addEventListener("click", () => {
          this._qa("[data-compressor]").forEach((b) =>
            b.classList.toggle("active", b === btn)
          );
        })
      );
      this._qa("[data-noise]", recordingModesEl).forEach((btn) =>
        btn.addEventListener("click", () => {
          this._qa("[data-noise]", recordingModesEl).forEach((b) =>
            b.classList.toggle("active", b === btn)
          );
          this._q("#noiseValue", recordingModesEl).textContent =
            btn.dataset.noise;
        })
      );
    };
    const _initHisongVideosModal = () => {
      const modalEl = this._q(
        "[data-name='hisong-videos-modal']",
        recordingModesEl
      );
      if (!modalEl) return;
      const closeBtn = this._q(".es1lp1rm__modal-close", recordingModesEl);
      modalEl.addEventListener("click", (event) => {
        if (event.target !== event.currentTarget) return;
        modalEl.classList.remove("open");
      });
      closeBtn.addEventListener("click", () => {
        modalEl.classList.remove("open");
        let videoMedia = this._q("video-media[playing]", modalEl);
        if (!!videoMedia) {
          videoMedia.pause();
        }
      });
    };
    const _initModalBtn = () => {
      const btnEl = this._q("[name='app-demo-btn']", recordingModesEl);
      if (!btnEl) return;

      btnEl.addEventListener("click", () => {
        const modalEl = this._q(
          "[data-name='hisong-videos-modal']",
          recordingModesEl
        );
        const tabActiveEl = this._q(
          "[data-name='app-view-tab'].active",
          recordingModesEl
        );
        const videosCards = this._qa("[data-name='hisong-video-card']");
        modalEl.classList.add("open");
        videosCards.forEach((el, inedx) => {
          if (el.dataset.title == tabActiveEl.dataset.appView) {
            el.classList.add("active");
            const videoMedia = this._q("video-media", el);
            if (!!videoMedia) {
              videoMedia.play();
            }
          } else {
            el.classList.remove("active");
          }
        });
      });
    };
    _initRouteWorkspaces();
    _initDAWChips();
    _initAppViewTabs();
    _initHisongPanel();
    _initHisongVideosModal();
    _initModalBtn();
  }

  initPurchase() {
    const purchaseEl = this._q(".extend-s1lp1-purchase");
    if (!purchaseEl) return;
    const packCards = this._qa(".es1lp1p__pack-card", purchaseEl);
    const productImgs = this._qa(".es1lp1p__purchase-product-img", purchaseEl);
    const checkoutRows = this._qa(".es1lp1p__checkout-row", purchaseEl);
    const accordions = this._qa(".es1lp1p__purchase-accordion", purchaseEl);
    const pdpLinkEl = this._q("#pdpLink", purchaseEl);
    const _initPackCards = () => {
      packCards.forEach((packCardEl, packCardIndex) => {
        if (!!pdpLinkEl && packCardEl.classList.contains("active")) {
          pdpLinkEl.href = packCardEl.dataset.variantUrl;
        }
        packCardEl.addEventListener("click", () => {
          packCards.forEach((el, index) => {
            el.classList.remove("active");
            productImgs[index].classList.remove("active");
            checkoutRows[index].classList.remove("active");
            productImgs[index].classList.remove("active");
            accordions[index].classList.remove("active");
          });
          packCardEl.classList.add("active");
          productImgs[packCardIndex].classList.add("active");
          checkoutRows[packCardIndex].classList.add("active");
          productImgs[packCardIndex].classList.add("active");
          accordions[packCardIndex].classList.add("active");
          if (!!pdpLinkEl) {
            pdpLinkEl.href = packCardEl.dataset.variantUrl;
          }
        });
      });
    };
    const _initAccordions = () => {
      this._qa(".es1lp1p__acc-button", purchaseEl).forEach((btn) =>
        btn.addEventListener("click", () => {
          const item = btn.closest(".es1lp1p__acc-item"),
            panel = this._q(".es1lp1p__acc-panel", item),
            open = item.classList.toggle("open");
          panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
        })
      );
    };
    _initPackCards();
    _initAccordions();
  }
}
